import React from "react";
import {Table} from "react-bootstrap";
import "./GenGenPlateCalculatedResult.css"
import {ColumnDef, flexRender, getCoreRowModel, useReactTable} from "@tanstack/react-table";

export const TanStackCalculatedResultTable: React.FC<{
    columns: any[];
    data: any[];
    cellClassFn: (cell: string, row: any, rowIndex: number, colIndex: number) => string;
}> = ({ columns, data, cellClassFn }) => {
    const tableColumns = React.useMemo<ColumnDef<any, any>[]>(() => {
        return columns.map(col => ({
            accessorKey: col.dataField,
            header: col.text,
            cell: info => {
                return info.getValue() as string
            },
            meta: { dataField: col.dataField } as any,
        }))
    }, [columns])

    const table = useReactTable({
        data: data || [],
        columns: tableColumns,
        getCoreRowModel: getCoreRowModel(),
    })

    const noData = !data || data.length === 0

    return (
        <div className="table-responsive">
            <Table hover striped bordered className={"small-table"}>
                <thead>
                {table.getHeaderGroups().map(headerGroup => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                            <th key={header.id}>
                                {flexRender(header.column.columnDef.header, header.getContext())}
                            </th>
                        ))}
                    </tr>
                ))}
                </thead>
                <tbody>
                    {noData ? (
                        <tr>
                            <td colSpan={tableColumns.length}>
                                <h6 className="text-primary">No data found!</h6>
                            </td>
                        </tr>
                    ) : (
                        table.getRowModel().rows.map((row) => (
                            <tr key={row.id}>
                                {row.getVisibleCells().map((cell) => {
                                    const value = cell.getValue() as string
                                    const dataField = (cell.column.columnDef.meta as any)?.dataField
                                    const colIndex = columns.findIndex(column => column.dataField === dataField)
                                    const className = cellClassFn(value, row.original, row.index, colIndex)
                                    return (
                                        <td key={cell.id} className={className}>
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    )
                                })}
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </div>
    )
}